export default "__VITE_ASSET__Bnb1aIMh__"